import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { InspectionModule } from './inspections/modules/inspection.module';
import { InspectionEditorModule } from './inspections/modules/inspection-editor.module';

import { SectionModule } from './sections/modules/section.module';
import { SectionEditorModule } from './sections/modules/section-editor.module';

import { FolderModule } from './folders/modules/folder.module';

import { PointEditorModule } from './points/modules/point-editor.module';
import { PointModule } from './points/modules/point.module';

import { NotFoundComponent } from './notfound.component';
import { AuthModule } from './auth/auth.module';

import { PeopleModule } from './people/people.module';
import { HomeComponent } from './home/home.component';
import { AdminHomeComponent } from './home/admin-home.component';

import { BasePageComponent } from './base-page.component';
import { BaseModalPageComponent } from './base-modal.component';
import { BasePluginMenuComponent } from './menus/plugins/base.menu';

import { ActionPlanModule } from './action-plans/modules/action-plan.module';

import { SnackBarComponent } from './shared/components/snack-bar/snack-bar.component';

import { LoadSpinnerComponent } from './shared/components/load-spinner/load-spinner.component';

import { SettingsModule } from './settings/modules/settings.module';
import { ChangePasswordPageComponent } from './changePassword/change-password.page';
import { SharedModule } from './shared.module';
import { ReportPdfListPageComponent } from './shared/pages/index';
import { PartsMessageComponent } from './shared/pages/parts-message/parts-message.component';
import { UnauthorizedComponent } from './shared/pages/unathorized/unauthorized.component';
import { ApiService, MissingStringsHandler, ApiLoaderFactory } from './shared/services';
import { OfflineApiService } from './shared/services/offlineApi.service';
import { httpInterceptorProviders } from './httpInterceptors';
import { MachinesModule } from './machines/machines.module';
import { StoreModule } from '@ngrx/store';
import { AppStoreModule } from './store/appStore.module';
import { CustomersModule } from './customers/customers.module';
import { InspectionModelModule } from './templates/modules/inspection-model.module';
@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    HomeComponent,
    AdminHomeComponent,
    ChangePasswordPageComponent,
    BasePageComponent,
    BaseModalPageComponent,
    BasePluginMenuComponent,
    SnackBarComponent,
    ReportPdfListPageComponent,
    PartsMessageComponent,
    UnauthorizedComponent,
    LoadSpinnerComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    InspectionModule,
    InspectionEditorModule,
    SectionEditorModule,
    PointEditorModule,
    PeopleModule,
    AuthModule,
    SectionModule,
    FolderModule,
    PointModule,
    ReactiveFormsModule,
    SharedModule,
    SettingsModule,
    ActionPlanModule,
    MachinesModule,
    CustomersModule,
    InspectionModelModule,
    AppStoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: ApiLoaderFactory,
        deps: [OfflineApiService]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingStringsHandler,
        deps: [ApiService]
      }
    }),
    StoreModule.forRoot({})
  ],
  providers: [httpInterceptorProviders, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule {}
